/**
 * Attendance & WFH module enums (M7, SRS §14–§15, ADR-056, ADR-057). Values are the Postgres
 * enum labels of the `attendance` schema (UPPER_SNAKE).
 */
export const PUNCH_DIRECTIONS = ['IN', 'OUT'];
/** Where the employee says they work for this punch (FR-ATT-3). */
export const PUNCH_MODES = ['OFFICE', 'WFH'];
/** App check-in, biometric device, approved regularisation, or HR correction (FR-ATT-3…10). */
export const PUNCH_SOURCES = ['APP', 'DEVICE', 'REGULARISED', 'HR'];
/** Geofence result of a punch (FR-ATT-4); `NA` for device / WFH / HR punches. */
export const GEOFENCE_RESULTS = ['INSIDE', 'OUTSIDE', 'NO_LOCATION', 'NA'];
/** A day's status (FR-ATT-8). */
export const DAY_STATUSES = [
    'PRESENT',
    'LATE',
    'HALF_DAY',
    'INCOMPLETE',
    'ABSENT',
    'ON_LEAVE',
    'HALF_LEAVE',
    'WFH',
    'HOLIDAY',
    'WEEKEND',
];
/** WFH days and regularisations follow their approval request. */
export const ATTENDANCE_REQUEST_STATUSES = [
    'PENDING',
    'APPROVED',
    'REJECTED',
    'CANCELLED',
];
/**
 * Why a punch needs HR review (FR-ATT-3, FR-ATT-4, ADR-081): an office punch outside every
 * office, a punch without location while `require_location` is on, a WFH punch without an
 * approved WFH day. Flagged punches are saved, never refused.
 */
export const PUNCH_FLAGS = ['OUTSIDE', 'NO_LOCATION', 'WFH_NOT_APPROVED'];
/**
 * Biometric device adapters (FR-ATT-5, ADR-082): `ZKTECO_ADMS` — ZKTeco devices pushing over
 * ADMS ("Cloud Server"), recognised by serial number and source IP; `GENERIC_PUSH` — any
 * middleware posting JSON with a per-device secret.
 */
export const DEVICE_KINDS = ['ZKTECO_ADMS', 'GENERIC_PUSH'];
//# sourceMappingURL=enums.js.map